export type LoadFlagHost = { __orderpilotLoaded?: boolean };

export function isLoaded(win: LoadFlagHost): boolean {
    return win.__orderpilotLoaded === true;
}

export function markLoaded(win: LoadFlagHost): void {
    win.__orderpilotLoaded = true;
}
